<template>
<div v-if="stream">
    <div v-if="stream.stream_link && stream.stream_link.trim()!=''" class="mb-4">
      <div style="margin:auto;text-align:center"><iframe :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()"  :src="stream.stream_link" frameborder="0" allowfullscreen="allowfullscreen"></iframe></div>
    </div>
    <div v-else>
    <!-- Vorher null!=eventState-->
      <h3 v-show="eventHasNotStarted && !(dateIsGreatherThanTreeMonth(stream.date))" class="text-center font-size-2"><!-- v-show="eventHasNotStarted" -->
        <RTCountdown :customStartDate="stream.date" :customEndDate="stream.endDate" :preReleaseMinutes="120" @updatedState="onUpdateCountdownState" />
      </h3>

      <div v-if="!streamIsLive && disableLink" class="image main mt-0"><img alt="Stream Cover" :src="stream.cover" /></div>
      <router-link v-if="!streamIsLive && !disableLink"  :to="'/stream/'+stream.id">
        <RTProjectCover class="mb-1" :stream="stream" :size="getReferentenIconSize()"/>
      </router-link>
      <div v-if="streamIsLive && showStreamLinks" class="w-100 mb-3 text-center">
        <h2 v-if="isMobile" class="text-center"><b>Livestream & Chat auf</b></h2>
        <RTStreamTv :stream="stream"/>

      <!--<iframe src="https://embed.restream.io/player/index.html?token=ddda61c34832cff136c99153e4233bb8" :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->
      <!--<iframe src="https://www.youtube.com/embed/live_stream?channel=UCz6VCxQ7FzTnnivonbgl3Jw&autoplay=1" :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->

      <!-- Chat -->
      <!-- https://www.youtube.com/live_chat?v=<your video ID>&embed_domain=<your blog domain> -->
    <!--<iframe src="https://www.youtube.com/live_chat?v=P_S-Edzvfoc&embed_domain=www.sofareisen.org" :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->
      </div>

      <slot></slot>
    <!-- Youtube und fb buttons-->
      <RTStreamLinks v-if="!streamIsLive && showStreamLinks" :expiredText="!isMobile" :titleText="!isMobile" :stream="stream"/>
      <p v-if="showStreamLinks" class="text-center"><i class="icon solid fa-clock fa-lg"></i> <b>Stream verpasst?</b> Für 24 Stunden findet ihr den Stream inklusive Interview <a target="_blank" rel="noreferrer" :href="(hasCustomYoutubeStream)?stream.custom_youtube_channel:'https://www.youtube.com/c/Sofareisen'"><br/>{{(hasCustomYoutubeStream)?`auf dem YouTube Kanal von ${stream.author}`:"HIER auf unserem YouTube Kanal"}}</a></p>
      <p v-if="stream.stream_help && showStreamLinks" class="streamInfoTxt">Bei technischen Problemen oder unerwarteten Ereignissen werden wir euch im <a :href="stream.stream_help" rel="noreferrer"  target="_blank">HIER</a> auf dem Laufenden halten.</p>
    </div>
</div>
</template>

<script>
import RTProjectCover from '@/components/RTProjectCover.vue'
import RTCountdown from '@/components/RTCountdown.vue'
import RTStreamLinks from '@/components/RTStreamLinks.vue'
import RTStreamTv from '@/components/RTStreamTv.vue'
import {helper} from '@/mixins/helper.js'
export default {
  name: 'RTStreamIncludingCountdown',
  mixins:[helper],
  components:{
    RTCountdown,
    RTProjectCover,
    RTStreamLinks,
    RTStreamTv
  },
  props:{
   stream:{
     type:Object
   },
   disableLink:{
     type:Boolean,
     default:false
   },
   forceLive:{
      type:Boolean,
      default:false
   },
   showStreamLinks:{
     type:Boolean,
     default:true
   }
  },
  watch:{
  },
  data: function() {
    return {
      youtubeId:"UCz6VCxQ7FzTnnivonbgl3Jw",
      eventState:null, //before_start, after_end, in_time
    };
  },
  computed:{
    hasCustomYoutubeStream(){
      return (this.stream && !this._.isEmpty(this.stream.custom_youtube_channel))
    },
    streamIsLive(){
      return (this.forceLive) || (!(null!=this.eventState && (this.eventHasNotStarted || this.eventHasEnded)));
    },
    eventHasNotStarted(){
      return this.eventState=='before_start';
    },
    eventHasStarted(){
      return this.eventState=='in_time';
    },
    eventHasEnded(){
      return this.eventState=='after_end';
    },
    streamButtons(){
      return {
        width:this.getMaxWidthOfPlayer()+'px'
      }
    }
   
  },
  methods:{
    onUpdateCountdownState(val){
      this.eventState=val;
      console.log('update event State');
      console.log(val);
    },

    getReferentenIconSize(){
      return (this.isSmallTouchDevice()?100:200)+'px';
    },
        
    getMaxWidthOfPlayer(){
      //screenWidth() -> einbauen
      return this.isSmallTouchDevice()?255:640;
    },
    getHeightOfPlayer(){
      return this.isSmallTouchDevice()?200:360;
    }
   
  },

  mounted(){
  },
};
</script>

<style scoped type='text/css'>

</style>